#### Content discoverability improvements

We’ve made a handful of improvements to the discoverability of content on the Developer Site:

1. Site search is now available on every page
1. Search results can now deep link to the relevant page section
1. Content is now indexable by external search engines like Google
